import { render, staticRenderFns } from "./ImportIcon.vue?vue&type=template&id=44813332&"
import script from "./ImportIcon.vue?vue&type=script&lang=js&"
export * from "./ImportIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports